<template>
  <div class="login">
    <form>
      <h1>Connexion</h1>

      <FormRow>
        <label for="login">Login</label>
        <input v-model="data.email" type="text" name="login" placeholder="somebody@somewhere.world" />
      </FormRow>

      <FormRow>
        <label for="password">Password</label>
        <input v-model="data.password" type="password" name="password" />
      </FormRow>

      <FormRow>
        <Button class="button" v-on:click.prevent="login">Login</Button>
      </FormRow>

      <div class="form-links">
        <SimpleLink href="#" class="link colored-bg">Register</SimpleLink>
        <SimpleLink href="#" class="link colored-bg">
          Forgottent password ?
        </SimpleLink>
      </div>
    </form>
    <div v-if="errorMsg" class="error-message">{{ errorMsg }}</div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import Button from '@/components/common/Button.vue'
import FormRow from '@/components/common/FormRow'
import SimpleLink from '@/components/common/SimpleLink.vue'

@Component({
  name: 'Login',
  components: {
    Button,
    FormRow,
    SimpleLink
  }
})
class Login extends Vue {
  data = {
    email: '',
    password: ''
  }

  errorMsg = ''

  login() {
    this.$fetch.post('/users/auth', this.data).then(
      (user) => {
        console.log('ok', user)
        this.saveUser(user) // tout se recharge dans App.vue, suite a cette modif

        if (this.$route.params.nextUrl != null) {
          this.$router.push(this.$route.params.nextUrl)
        } else {
          this.$router.push({ name: 'Home' })
        }
      },
      (err) => {
        console.log('ko', err)
        this.errorMsg = err.cause
      }
    )
  }
}

export default Login
</script>

<style scoped lang="less">
@import '../assets/less/globals';

h1 {
  color: white;
}

.login {
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  justify-content: center;

  min-height: calc(~'100vh' - var(--header-height) - var(--footer-height));

  background-color: var(--color-main);
  color: #fff;

  form {
    padding: var(--margin--medium) var(--margin--large);

    border-radius: 10px 10px 0 0;
    box-shadow: 0 -16px 23px #0001;

    animation: reveal-down 1s ease;
  }
}

.form-links {
  display: flex;
  flex-direction: column;
  align-items: center;
}

input[type='text'],
input[type='password'] {
  background-color: #fff5;
  border-color: #fff;
}

.button {
  margin-bottom: var(--margin--medium);
  margin-top: var(--margin--small);
  padding: var(--margin--small) var(--margin--medium);

  background-color: #fff;
  border-color: var(--color-black);
  color: var(--color-black);
  font-size: 16px;

  transition: background 0.3s ease, color 0.3s ease;

  &:hover,
  &:focus {
    background-color: transparent;
    color: #fff;
  }
}


.error-message {
  background: #e3d0d0;
  padding: 20px;
  list-style: none;
  border-left: 10px solid var(--color-error);
  color: var(--color-black);

  font-size:14px;

  animation: reveal-down 1s ease;
}


@media screen and (min-width: @screen-desktop-low) {
  form {
    min-width: 400px;
  }
}
</style>
